import { IssueTypeDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

export interface UseIssueTypeParams {
  id: string;
}

export function useIssueType({ id }: UseIssueTypeParams) {
  const api = useApi();

  return useQuery<IssueTypeDto, ExtendedAxiosError>({
    queryKey: ['issue-types', id],
    queryFn: () => api.issueTypesApi.issueType(id).then((r) => r.data),
    enabled: !!id,
  });
}
